import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'
import SplitText from 'gsap/SplitText'
import svg4everybody from 'svg4everybody'
import { pageComponents, siteComponents } from './components'
import { createComponents, loadComponents } from './lib/Component'
import LazyLoad from 'vanilla-lazyload'

import { isMobile } from './lib/Utils'

gsap.registerPlugin(ScrollTrigger, SplitText)
window.addEventListener('elementor/frontend/init', function () {
	elementorFrontend.hooks.addAction('frontend/element_ready/global', () => {
		const elementorLazyLoad = new LazyLoad({
			elements_selector: '.js-lazy',
		})

		elementorLazyLoad.update()
	})
})

window.onload = () => {
	/**
	 * Use external SVG sprite-maps
	 */
	svg4everybody()

	new LazyLoad({
		elements_selector: '.js-lazy',
	})

	/**
	 * Site components - created once
	 */
	createComponents(siteComponents)

	/**
	 * Page components - mounted if found on page
	 */
	const pageSelector = '.js-page-main'
	loadComponents(pageComponents, pageSelector)
	ScrollTrigger.refresh() // Refresh smooths scroll after for all loadComponents

	if (isMobile()) document.querySelector('html').classList.add('is-mobile')
}
